import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';
import Layout from './hoc/Layout/Layout'
import Home from './container/Home/Home';
import { BrowserRouter,Route } from 'react-router-dom';
import Contact from './components/Pages/Contact/Contact';
import axios from './firebase-axios';
import { data } from 'autoprefixer';
import Popup from 'react-popup';

class App extends Component {
  
  componentDidMount() {
  }
  render() {
    return (
      <BrowserRouter>
        <Layout>
        <Popup
    className="mm-popup"
    btnClass="mm-popup__btn"
    closeBtn={true}
    closeHtml={null}
    defaultOk="Ok"
    defaultCancel="Cancel"
    wildClasses={false}
    escToClose={true} />
          <Route path="/" exact component={Home} />
          <Route path="/contact-me" excat component={Contact} />
        </Layout>
      </BrowserRouter>
    );
  }

}

export default App;



// WEBPACK FOOTER //
// ./src/App.js